import React from "react";

export default function CookiePolicy() {
  return (
    <div className="relative overflow-hidden bg-[#FFF8EE] pt-28 pb-20 min-h-screen">
      {/* Background Gradients */}
      <div className="absolute top-[-250px] left-[-200px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.12)_0%,transparent_70%)] pointer-events-none" />
      <div className="absolute bottom-[-300px] right-[-200px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(104,138,94,0.1)_0%,transparent_70%)] pointer-events-none" />

      <div className="relative z-20 max-w-[960px] mx-auto px-6">
        <div className="rounded-[40px] border border-[#F4D9B5] bg-white/70 backdrop-blur-2xl p-8 md:p-14 shadow-[0_20px_60px_rgba(0,0,0,0.03)]">
          <h1 className="text-[36px] md:text-[50px] font-bold text-[#111111] font-poppins mb-4" style={{ fontFamily: "Poppins" }}>Cookie Policy</h1>
          <p className="text-xs text-[#777] mb-10">Last Updated: June 29, 2026</p>
          
          <div className="prose max-w-none text-[#444] text-[15px] leading-[30px] space-y-8">
            <p>
              This policy explains how Divyyog Foundation uses cookies and similar technologies to recognize you when you visit our website. It explains what these technologies are, why we use them, and your rights to control them.
            </p>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>1. What are Cookies?</h2>
              <p>
                Cookies are small text files placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners to make their websites work, or to work more efficiently, as well as to provide reporting information.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>2. Types of Cookies We Use</h2>
              <p>
                We use first-party and third-party cookies for several reasons:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Essential Cookies:</strong> These cookies are strictly necessary to provide you with services available through our website and to use some of its features, such as accessing secure dashboards or processing payments.</li>
                <li><strong>Preference Cookies:</strong> These cookies allow our website to remember choices you make (such as dashboard layout preferences or theme settings) to provide a more personalized experience.</li>
                <li><strong>Analytics Cookies:</strong> These cookies collect aggregate information to help us understand how our website is being used and improve page load speeds (e.g., tracking entry pages, exit pages, or loading errors).</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>3. How Can You Control Cookies?</h2>
              <p>
                You have the right to decide whether to accept or reject cookies. You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our website, though your access to some functionality and secure areas of our website may be restricted.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-[22px] font-semibold text-[#111] font-poppins pt-4" style={{ fontFamily: "Poppins" }}>4. Updates to this Policy</h2>
              <p>
                We may update this cookie policy from time to time in order to reflect changes to the cookies we use or for other operational, legal, or regulatory reasons. Please re-visit this page regularly to stay informed.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
